import React, {Component} from 'react'
import {
    DisplayBlockDiv,
    DisplayItemInput,
    DisplayItemInputTitleNoMargin,
    DisplayItemSelect,
    DisplayItemSelectIcon,
} from '../../../../styledComponents/DisplayItem';
import {Nullable} from '../../../../app/TypeHelpers';
import {StyledDiv, StyledInput, StyledSelect} from '../../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import {SecondaryButton} from '../../../../styledComponents/Button';
import {NatGetRidge} from '../../ridge/repository/NatGetRidge';
import {Box} from '@mui/material';


interface Props {
    searchUser: (ridgeCd: string, roomNumber: string) => void
    ridgeList: NatGetRidge
}

interface States {
    ridgeCd: string
    roomNumber: string
}

export default class NatResidentCondominiumSelectFormComponent extends Component<Props, States> {
    constructor(props: Props) {
        super(props);

        this.state = {
            ridgeCd: '',
            roomNumber: '',
        };

        this.handleRidgeChange = this.handleRidgeChange.bind(this);
        this.handleRoomNumberChange = this.handleRoomNumberChange.bind(this);
        this.handleClickSearch = this.handleClickSearch.bind(this)
    }

    // 棟名
    handleRidgeChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({ridgeCd: event.target.value})
    }

    // 棟名
    handleRoomNumberChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roomNumber: event.target.value})
    }

    // 検索
    handleClickSearch(): void {
        this.props.searchUser(this.state.ridgeCd, this.state.roomNumber)
    }


    render(): Nullable<React.ReactElement> {
        return (
            <Box pt={'15px'}>
                <DisplayBlockFlex>
                    <DisplayItemInputTitleFlexItem>棟名</DisplayItemInputTitleFlexItem>
                    <RidgeCdSelectIcon>
                        <RidgeCdSelect
                            onChange={this.handleRidgeChange}>
                            <option value="">すべて表示</option>
                            {this.props.ridgeList.details && this.props.ridgeList.details.map((ridge, index) => (
                                <option value={ridge.ridgeCd} key={index}>{ridge.ridgeName}</option>
                            ))}
                        </RidgeCdSelect>
                    </RidgeCdSelectIcon>
                </DisplayBlockFlex>
                <DisplayBlockFlex>
                    <DisplayItemInputTitleFlexItem>部屋番号</DisplayItemInputTitleFlexItem>
                    <FormInputContainer>
                        <RoomNumberInput
                            type="text"
                            name="roomNumber"
                            maxLength={4}
                            onChange={this.handleRoomNumberChange}
                        />
                    </FormInputContainer>

                </DisplayBlockFlex>
                <DisplayBlockDiv>
                    <SecondaryButton onClick={this.handleClickSearch}>
                        検索
                    </SecondaryButton>
                </DisplayBlockDiv>
            </Box>
        )
    }
}

const DisplayBlockFlex: StyledDiv = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
`;


const DisplayItemInputTitleFlexItem = styled(DisplayItemInputTitleNoMargin)`
  flex-basis: 100px;
`;

const FormInputContainer: StyledDiv = styled.div`
 flex: 1 0 0%;
`;

const RoomNumberInput: StyledInput = styled(DisplayItemInput)`
 flex: 1 0 0%;
 width: 100%
`;
const RidgeCdSelect: StyledSelect = styled(DisplayItemSelect)`
 width: 100%
`;

const RidgeCdSelectIcon = styled(DisplayItemSelectIcon)`
 flex: 1 0 0%;
   &:after {
     right: 5%;
   }
`;
